import React from 'react';
import {FormattedMessage, IntlProvider} from 'react-intl';

import {makeToolTipUrl} from "utils/DBUtils";
import {enUSmessage} from 'i18n/en-US.js';

export const SpotTheDifferenceHeadlineToolTip = (props) => (
  <div>
    The title of the step featured on the top.
    <br/>
    <img src={makeToolTipUrl('spot-the-difference/1.CMS-STD-headline.png')} width="100%"/>
  </div>
);

export const SpotTheDifferenceIntroCopyToolTip = (props) => (
  <div>
    Brief copy overview of the break.
    <br/>
    <img src={makeToolTipUrl('spot-the-difference/2.CMS-STD-intro.png')} width="100%"/>
  </div>
);

export const SpotTheDifferenceButtonTextToolTip = (props) => (
  <div>
    CTA for the reader begin the STD. Default: “Get Started”.
    <br/>
    <img src={makeToolTipUrl('spot-the-difference/3.CMS-STD-button-text.png')} width="100%"/>
  </div>
);

export const SpotTheDifferenceExampleImageToolTip = (props) => (
  <div>
    An example image of the original Spot the Difference image.
    <br/>
    <img src={makeToolTipUrl('spot-the-difference/4.CMS-STD-example-img.png')} width="100%"/>
  </div>
);

export const SpotTheDifferenceInstructionHeadlineToolTip = (props) => (
  <div>
    The title of the instruction.
    <br/>
    <img src={makeToolTipUrl('spot-the-difference/5.CMS-STD-instruction-headline.png')} width="100%"/>
  </div>
);

export const SpotTheDifferenceInstructionDescriptionToolTip = (props) => (
  <div>
    Extra copy for the instructions to elaborate or add info.
    <br/>
    <img src={makeToolTipUrl('spot-the-difference/6.CMS-STD-instruction-description.png')} width="100%"/>
  </div>
);

export const SpotTheDifferenceSceneSectionHeadlineToolTip = (props) => (
  <div>
    The title on the Spot Page of this break featured in headline bar.
    <br/>
    <img src={makeToolTipUrl('spot-the-difference/7.CMS-STD-Spot-headline.png')} width="100%"/>
  </div>
);

export const SpotTheDifferenceTimeLimitToolTip = (props) => (
  <div>
    The number of seconds between 0-180, the user has to find all the differences.
    <br/>
    <img src={makeToolTipUrl('spot-the-difference/8.CMS-STD-time-limit.png')} width="100%"/>
  </div>
);

export const SpotTheDifferenceOriginalImageToolTip = (props) => (
  <div>
    The first image with no differences.
    <br/>
    <img src={makeToolTipUrl('spot-the-difference/9.CMS-STD-origional-img.png')} width="100%"/>
  </div>
);

export const SpotTheDifferenceDifferencesImageToolTip = (props) => (
  <div>
    A second image with 4-8 differences in it.
    <br/>
    <img src={makeToolTipUrl('spot-the-difference/10.CMS-STD-difference-img.png')} width="100%"/>
  </div>
);

export const SpotTheDifferenceIdentifyDifferencesToolTip = (props) => (
  <div>
    Select the areas where the differences are on either image. If a wrong area is selected, click the X next to the corresponding number and reselect.
    <br/>
    <img src={makeToolTipUrl('spot-the-difference/11.CMS-STD-identify-difference.png')} width="100%"/>
  </div>
);



// WEBPACK FOOTER //
// ./public/components/break/tooltips/spot-the-difference-tool-tips.jsx